var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99775 11.9463C5.763 11.9463 3 12.4563 3 14.4963C3 16.537 5.74575 17.065 8.99775 17.065C12.2325 17.065 14.9955 16.5558 14.9955 14.515C14.9955 12.4743 12.2505 11.9463 8.99775 11.9463Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99781 10.0029C11.2013 10.0029 12.9668 8.23669 12.9668 6.03394C12.9668 3.83119 11.2013 2.06494 8.99781 2.06494C6.79506 2.06494 5.02881 3.83119 5.02881 6.03394C5.02881 8.23669 6.79506 10.0029 8.99781 10.0029Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeBlack);
export default __webpack_public_path__ + "static/media/employee-black.1ac602ca28cd5e63633258e4607e2e1b.svg";
export { ForwardRef as ReactComponent };